// src/context/GeoContext.jsx
import React, { createContext, useContext, useEffect, useState } from "react";
import { getBootstrappedCC } from "../utils/geo";

const GeoCtx = createContext({ cc: "" });

export const GeoProvider = ({ children }) => {
  const [cc, setCC] = useState(""); // start empty, SSR-safe

  useEffect(() => {
    // 1) Bootstrap cc from window.__DF_CC / cookie on client
    const initialCC = getBootstrappedCC();
    if (initialCC && initialCC !== cc) {
      setCC(initialCC);
    }

    // 2) Listen for df:cc events for live updates
    const handler = (e) =>
      setCC(String(e?.detail?.cc || "").toUpperCase());

    if (typeof document !== "undefined") {
      document.addEventListener("df:cc", handler);
      return () => document.removeEventListener("df:cc", handler);
    }
  }, []); // run once on client

  return <GeoCtx.Provider value={{ cc }}>{children}</GeoCtx.Provider>;
};

export const useGeo = () => useContext(GeoCtx);
